import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type AttachmentPreview from 'owa-service/lib/contract/AttachmentPreview';
import type ConversationNode from 'owa-service/lib/contract/ConversationNode';

export default createStore('spacesMailItemAssetStore', {
    attachmentPreviews: new ObservableMap<string, AttachmentPreview[] | null>(),
    unreadReplies: new ObservableMap<string, ConversationNode[]>(),
});
